import { Icon } from '@ids/react-icon';
import * as IDSIcons from '@ids/react-icons';
import { Ui24Like } from '@ids/react-icons';
import type { JSX } from 'react';

type IDSIconName = keyof typeof IDSIcons;

function toPascalCase(value: string): string {
  return value
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

type IdsIconProps = {
  name: string;
  size?: string | number;
};

export function IdsIcon({ name, size }: IdsIconProps): JSX.Element {
  const pascalName = toPascalCase(name);

  const iconKey = (Object.keys(IDSIcons) as IDSIconName[]).find((key) =>
    size ? key.endsWith(`${size}${pascalName}`) : key.endsWith(pascalName),
  );

  if (!iconKey) {
    return <Ui24Like />;
  }

  const match = iconKey.match(/^([A-Z][a-z]+)(\d+)/);
  const [, group, resolvedSize] = match!;

  return <Icon group={group.toLowerCase()} size={resolvedSize} icon={name} />;
}
